module.exports = __webpack_public_path__ + "static/arcadium-mockup-0d7b941271bc67285f33c433f26688f2.png";